import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { bezirke } from "@/data/bezirke";
import { useLang } from "@/i18n/LanguageContext";

export const BezirkeGrid = () => {
  const { t } = useLang();
  return (
    <section id="bezirke" className="py-20 md:py-24 bg-background">
      <div className="container">
        <div className="max-w-2xl mb-12">
          <span className="text-accent font-semibold uppercase tracking-widest text-sm">{t("section.bezirke.kicker")}</span>
          <h2 className="font-display text-4xl md:text-6xl text-primary mt-3 mb-4">{t("section.bezirke.title")}</h2>
          <p className="text-muted-foreground text-lg">{t("section.bezirke.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {bezirke.map((b) => (
            <Link
              key={b.slug}
              to={`/bezirke/${b.slug}`}
              className="group flex flex-col gap-1 bg-card border border-border rounded-xl px-4 py-4 hover:border-accent hover:shadow-card-soft transition-smooth"
            >
              <div className="flex items-center gap-2 text-accent">
                <MapPin className="w-4 h-4 shrink-0" />
                <span className="text-xs font-bold tracking-wide">{b.plz}</span>
              </div>
              <span className="font-semibold text-primary text-sm leading-tight">{b.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};